<template>
  <ocr-controller v-slot="{ view, switchto, ocrEnabled }">
    <validation-observer v-slot="{ handleSubmit }" tag="form" @submit.prevent>
      <div>
        <div
          v-if="view === 'ocr-patient'"
          class="py-4 max-w-screen-sm mx-auto space-y-10"
        >
          <form-group-patient-ocr
            :errors="errors"
            :controls="control"
            @input:group="onInput"
            @on:cancel="switchto('normal')"
            @on:ocr_scan="$emit('on:ocr_scan', $event)"
          >
            <h3
              slot="group:title"
              class="w-full text-xl text-center font-bold mb-6"
            >
              Save time by uploading your Photo ID or Driver's License
            </h3>
          </form-group-patient-ocr>
        </div>
        <div
          v-else-if="view === 'ocr-insurance'"
          class="py-4 max-w-screen-sm mx-auto space-y-10"
        >
          <form-group-insurance-ocr
            :errors="errors"
            :controls="control"
            @input:group="onInput"
            @on:cancel="switchto('normal')"
            @on:ocr_scan="$emit('on:ocr_scan', $event)"
          >
            <h3
              slot="group:title"
              class="w-full text-xl text-center font-bold mb-6"
            >
              Save time by uploading your Insurance Card
            </h3>
          </form-group-insurance-ocr>
        </div>

        <div
            v-else-if="view === 'ocr-secondary-insurance'"
            class="py-4 max-w-screen-sm mx-auto space-y-10"
        >
          <form-group-secondary-insurance-ocr
              :errors="errors"
              :controls="control"
              @input:group="onInput"
              @on:cancel="switchto('normal')"
              @on:ocr_scan="$emit('on:ocr_scan', $event)"
          >
            <h3
                slot="group:title"
                class="w-full text-xl text-center font-bold mb-6"
            >
              Save time by uploading your Insurance Card
            </h3>
          </form-group-secondary-insurance-ocr>
        </div>

        <div v-else class="max-w-screen-sm mx-auto space-y-10">
          <div v-if="ocrEnabled">
            <button-ocr @click="switchto('ocr-patient')">
              Save some time and upload your Photo ID or Driver's License
            </button-ocr>
          </div>
          <form-group-filter
            :errors="errors"
            :controls="control"
            @input:group="onInput"
          >
            <h3 slot="group:title" class="w-full text-lg font-bold mb-2">
              1. Select one
            </h3>
          </form-group-filter>
          <form-group-patient
            :errors="errors"
            :controls="{ ...control, sameday: true }"
            @input:group="onInput"
          >
            <h3 slot="group:title" class="w-full text-lg font-bold mb-2">
              2. Patient Information hahah
            </h3>
          </form-group-patient>
          <form-group-insurance
            v-if="isInsuranceEnabled"
            :errors="errors"
            :controls="control"
            @input:group="onInput"
          >
            <h3 slot="group:title" class="w-full text-lg font-bold mb-2">
              3. Do you have dental insurance?
            </h3>
            <div
              v-if="ocrEnabled && control.has_insurance"
              slot="insert:insurance-ocr"
              class="sm:col-span-2"
            >
              <button-ocr @click="switchto('ocr-insurance')">
                Save time by uploading your Insurance Card
              </button-ocr>
            </div>
          </form-group-insurance>

          <form-group-secondary-insurance
              :errors="errors"
              :controls="control"
              @input:group="onInput"
          >
            <h3 slot="group:title" class="w-full text-lg font-bold mb-2">
              Secondary Insurance Information
            </h3>
            <div
                v-if="ocrEnabled && control.has_insurance && control.has_secondary_insurance"
                slot="insert:insurance-ocr"
                class="sm:col-span-2"
            >
              <button-ocr @click="switchto('ocr-seondary-insurance')">
                Save time by uploading your Insurance Card
              </button-ocr>
            </div>
          </form-group-secondary-insurance>

          <div class="z-50 flex flex-grow bg-white py-6 md:sticky md:bottom-0">
            <button-primary
              type="submit"
              class="w-full px-10 py-3 lg:w-auto mx-auto"
              @click="handleSubmit(onSubmit)"
            >
              Book Appointment
            </button-primary>
          </div>
        </div>
      </div>
    </validation-observer>
  </ocr-controller>
</template>

<script>
import Base from "@/components/StepBase";
import FormGroupInsurance from "@/components/FormGroup/FormGroupInsurance";
import FormGroupPatient from "@/components/FormGroup/FormGroupPatient";
import ButtonPrimary from "@/components/Button/ButtonPrimary.vue";
import FormGroupPatientOcr from "@/components/FormGroup/FormGroupPatientOcr.vue";
import FormGroupInsuranceOcr from "@/components/FormGroup/FormGroupInsuranceOcr.vue";
import FormGroupFilter from "@/components/Sameday/FormGroup/FormGroupFilter.vue";
import OcrController from "@/components/OcrController.vue";
import ButtonOcr from "@/components/Button/ButtonOcr.vue";
import { calcDiff } from "@/helper.js";
import FormGroupSecondaryInsurance from "@/components/FormGroup/FormGroupSecondaryInsurance";
import FormGroupSecondaryInsuranceOcr from "@/components/FormGroup/FormGroupSecondaryInsuranceOcr";

export default {
  extends: Base,
  components: {
    FormGroupInsurance,
    FormGroupPatient,
    ButtonPrimary,
    FormGroupPatientOcr,
    FormGroupInsuranceOcr,
    FormGroupFilter,
    OcrController,
    ButtonOcr,
    FormGroupSecondaryInsurance,
    FormGroupSecondaryInsuranceOcr
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isInsuranceEnabled() {
      return this.control?.locations?.settings?.insurance_enabled;
    },
  },
  methods: {
    onSubmit() {
      this.$emit("on:step", 2);
      this.$emit("on:scroll", "top");
      this.$emit("on:field", {
        value: "sameday",
        key: "type",
      });
      this.onNextStep(this.form?.location?.location_id);

      // Update store and record the total booking time in seconds
      this.$store.commit("subFieldUpdate", {
        value: calcDiff(this.$store?.state?.appLoadTime),
        key: "totalBookingTimeInSeconds",
        pKey: "meta",
      });

      // Emit to `init.js` if the user has submitted the scheduling form
      this.$emit("on:submitted", {
        event: "scheduling-submitted",
        location: this.control?.locations,
        companyId: this.$store.state?.config?.companyId,
        totalBookingTimeInSeconds:
          this.$store.state?.meta?.totalBookingTimeInSeconds,
      });
    },
    onInput({ value, key }) {
      this.$emit("on:field", { value, key });
    },
    onNextStep(location_id) {
      this.$emit("on:nextstep", {
        event: "scheduling-step",
        mode: "sameday",
        location_id,
        value: 2,
      });
    },
  },
};
</script>
